import { PropsWithChildren } from 'react';

import { cx } from 'libs/ui/theme';
// eslint-disable-next-line no-restricted-imports
import { NavLink } from 'react-router-dom';
import { TestAttributeProps } from 'types/testAttribute';

import { NavigationLinkClasses } from './types';

interface Props extends TestAttributeProps {
  to: string;
  className?: string;
}

export const NavigationLink = ({
  children,
  className,
  datax,
  to,
}: Props & PropsWithChildren) => (
  <NavLink
    className={({ isActive }) =>
      cx(isActive && NavigationLinkClasses.activeLink, className)
    }
    datax={datax}
    to={to}
  >
    {children}
  </NavLink>
);
